<template>
  <div class="page">
    <div class="card">
      <div class="top">
        <div class="title">银联待提现金额(元)</div>
        <div class="rmb">¥ {{ walletInfo.availableBalance || 0 }}</div>
      </div>
      <div class="bottom">
        <div class="list-box">
          <div class="item">
            <span class="key">累计提现金额</span>
            <span class="value">¥{{walletInfo.totalWithdrawalAmount || 0 }}</span>
          </div>
          <!-- <div class="item">
            <span class="key">提现处理中金额</span>
            <span class="value">¥{{walletInfo.pendingAmount || 0}}</span> 
          </div> -->
        </div>
        <div class="list-box">
          <div class="item">
            <span class="key">冻结保证金</span>
            <span class="value">¥{{walletInfo.frozenMarginAmount || 0 }}</span>
          </div>
          <div class="item">
            <van-button type="primary" size="mini" color="#FF6B31" :disabled="walletInfo.frozenMarginAmount <= 0" @click="earnestMoneyWithdrawal">保证金提现</van-button>
          </div>
        </div>
      </div>
    </div>
    <div class="tips-box">
      提示: <br/>
      一、关于银联待提现金额  <br/>
      1.1“银联待提现金额”是该商家自己对应的银联商户号中，待提现金额汇总数; <br/>
      1.2 银联待提现金额为银联支付平台扣除0.4%手续费后的金额； <br/>
      1.3 银联待提现金额不包含“冻结保证金”。 <br/>
      二、关于“冻结保证金" <br/>
      2.1 为了降低客户对全友平台的投诉，所有商家均要留存500元做为客户退款保证金； <br/>
      2.2 “冻结保证金"金额来源于平时客户支付的交易款，不需要单独向平台打款； <br/>
      2.3 “冻结保证金"金额退款：若商家不使用拓客宝，方可发起退保证金申请；申请一经提交后，该商家所属的所有职员均不能再进拓客宝系统，且无法撤消退款申请，慎点！！ <br/>
      三、关于提现 <br/>
      点击右下角“提现”，即可发起提现操作，提现金到指定账户（即银联商户号绑定的法人银行卡，或公司对公账户）。 <br/>
      四、关于提现记录 <br/>
      查看历史“提现记录”，点击左下角“记录”，即可查看 。 <br/>
    </div>
    <div style="height: 90px;"></div>
    <div class="footer">
      <van-button class="button" @click="unionpayRecord">记录</van-button>
      <van-button type="primary" class="button bgd" :disabled="walletInfo.availableBalance <= 0" @click="withdrawal">提现</van-button>
    </div>
    <withdrawal-pop ref="withdrawalRef" :availableBalance="walletInfo.availableBalance" @withdrawSuccess="unionPayBalance"/>
  </div>
</template>

<script>
import withdrawalPop from './compoents/withdrawal-pop.vue'
export default {
  components: { withdrawalPop },
  data() {
    return {
      walletInfo: {},
    };
  },
  mounted() {
    this.unionPayBalance();
  },
  methods: {
    withdrawal() {
      const {availableBalance } = this.walletInfo 
      this.$router.push({
        path: '/unionpay-withdrawal',
        query: { 
          balance: availableBalance
        }
      })
    },
    earnestMoneyWithdrawal() {
      this.$refs.withdrawalRef.open()
    },

    unionpayRecord() {
      this.$router.push({
        path: '/record',
        query: {
          walletId: this.walletInfo.walletId,
          walletType: 2
        },
      });
    },
    unionPayBalance() {
      this.$api.withdrawal.unionPayBalance().then((res) => {
        if (res.data) {
          this.walletInfo = res.data
        }
      });
    },
  }
}
</script>

<style lang="stylus" scoped>
  .page {
    padding: 15px;
    height: 100vh;
    overflow-y: auto;
    box-sizing: border-box;
    background: #fff;
    .card {
      min-height: 180px;
      border-radius: 13px;
      background: #F4F4F4;
      .top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 133px;
        color: #fff;
        padding-left: 20px;
        box-sizing: border-box;
        background: url("https://img3.quanyou.com.cn/joyNew/group1/M00/46/D7/rB8LrmZZbxiAAXgDAADfGeLPI08949.png");
        background-size: 100% 100%;
        .title {
          font-size: 17px;
        }
        .rmb {
          font-weight: bold;
          font-size: 28px;
          margin-top: 6px;
        }
      }
      .bottom {
        padding: 0 14px 14px 14px;
        .list-box {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;
          .item {
            font-size: 14px;
            .key {
              color: #666666;
              margin-right: 6px;
            }
            .value {
              color: #FF6B31;
              font-weight: bold;
            }
          }
        }
      }
    }
    .tips-box {
      color: #999999;
      font-size: 14px;
      line-height: 22px;
      margin-top: 35px;
    }
    .footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: space-around;
      width: 100%;
      height: 84px;
      background: #FFFFFF;
      box-shadow: 0px -3px 9px 0px rgba(220, 220, 220, 0.3);
      .button {
        width: 138px;
        height: 43px;
        font-size: 17px;
        color: #FF6B31;
        text-align: center;
        line-height: 43px;
        border-radius: 8px;
        border: 1px solid #FF6B31;
        margin-top: 10px;
      }
      .bgd {
        color: #FFFFFF;
        background: #FF6B31;
      }
    }
  }
</style>